import { TalkativeInitializer } from '@phx/talkative';

import { useFlags } from '../../hooks/use-flags';
import { usePatientContext } from '../../hooks/use-patient-context';

export interface TalkativeProps {
    env: string;
    tollfreestates: string[];
}

export const MyPhxTalkativeInitializer = () => {
    const { patient } = usePatientContext();
    const { myPhxTalkativeProps } = useFlags();
    const tollFreeStates = (myPhxTalkativeProps as TalkativeProps | undefined)
        ?.tollfreestates;

    return (
        <TalkativeInitializer
            tollFreeStates={tollFreeStates}
            patientState={patient?.address?.state ?? null}
        />
    );
};
